import React from 'react'
import styles from './Label.module.scss'

interface LabelProps {
  children: React.ReactNode
  htmlFor?: string
  required?: boolean
  className?: never
}

export const Label: React.FC<LabelProps> = ({ children, htmlFor, required }) => (
  <label htmlFor={htmlFor} className={styles.label}>
    {children}
    {required && <span className={styles.required}>*</span>}
  </label>
)
